<template>
  <div
    v-observe-visibility="{
      callback: onVisibilityChanged,
      once: true,
    }"
    class="asd20-factoid"
  >
    <div class="asd20-factoid__value">
      <small v-if="prefix">{{ prefix }}</small
      ><asd20-count-up
        :start-val="start"
        :end-val="end"
        :decimals="decimals"
        :duration="duration"
        :options="options"
        @ready="onReady"
      /><small v-if="suffix">{{ suffix }}</small>
    </div>
    <div v-if="label" class="asd20-factoid__label">{{ label }}</div>
  </div>
</template>

<script>
import Asd20CountUp from '../../../components/atoms/Asd20CountUp'
import { ObserveVisibility } from 'vue-observe-visibility'

export default {
  name: 'Asd20Factoid',
  components: { Asd20CountUp },

  directives: {
    ObserveVisibility,
  },
  props: {
    value: { type: String, default: 'Factoid' },
    label: { type: String, default: '' },
    prefix: { type: String, default: '' },
    suffix: { type: String, default: '' },
    start: { type: Number, default: 0 },
    end: { type: Number, default: 0 },
    decimals: { type: Number, default: 0 },
    duration: { type: Number, default: 1 },
    once: { type: Boolean, default: true },
    options: {
      type: Object,
      default: () => ({
        useEasing: false,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: '',
      }),
    },
  },
  data: () => ({
    instance: null,
  }),
  computed: {
    supportsIntersectionObserver() {
      return 'IntersectionObserver' in window
    },
  },
  methods: {
    onReady(instance) {
      this.instance = instance
      if (!this.supportsIntersectionObserver) {
        this.instance.start()
      }
    },
    onVisibilityChanged(isVisible) {
      if (this.instance && isVisible) {
        this.instance.reset()
        this.instance.start()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

$factoid-bg: var(--color__tertiary);
$factoid-fg: var(--website-card__reverse-background-color);

.asd20-factoid {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: space(1) 0;
  background: $factoid-bg;
  // background-image: url('/statics/images/chalk-dark.png');
  background-size: 320px auto;
  background-position-y: top;
  box-sizing: border-box;

  &__value {
    color: var(--color__primary-s10);
    font-size: 2.15rem;
    font-weight: bold;
    small {
      font-size: 1.15rem;
    }
  }
  &__label {
    font-size: 0.85rem;
    font-weight: 300;
    // text-transform: uppercase;
    color: var(--color__primary-s80);
    // white-space: nowrap;
    opacity: 0.75;
  }
}

@media (min-width: 1024px) {
  .asd20-factoid {
    // padding: space(1) space(2);

    &__value {
      font-size: 2.75rem;
    }
    &__label {
      font-size: 1.15rem;
    }
  }
}
</style>
